import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/authContext";
import { canAccess, getDefaultRoute } from "../access";

export default function RoleRoute({ allowedRoles }) {
  const { user, effectiveUser } = useAuth();

  if (!user) return <Navigate to="/login" replace />;

  const accessUser = effectiveUser || user;
  return canAccess(accessUser, allowedRoles)
    ? <Outlet />
    : <Navigate to={getDefaultRoute(accessUser)} replace />;
}